export default __webpack_public_path__ + "static/media/seller_collection_agency.51bc4f5b.xlsx";